import { useMutation } from "@apollo/client";
import { registerFeatureAppConfigurations } from "../../container/AllServiceBundleView";
export const useRegisterFeatureAppConfigurations = (configs, envId) => {
    const [registerFeatureAppConfiguration] = useMutation(registerFeatureAppConfigurations, {
        variables: { configs, envName: envId },
    });
    return registerFeatureAppConfiguration;
};
